export interface IDeleteAssociationLogo {
    urls: string[];
}
